export var TourStatus;
(function (TourStatus) {
    TourStatus["Scheduled"] = "Scheduled";
    TourStatus["Completed"] = "Completed";
    TourStatus["Cancelled"] = "Cancelled";
})(TourStatus || (TourStatus = {}));
//# sourceMappingURL=tour.js.map